<script lang="ts">
	import { GlobalHomeContext } from '#lib/websites/home/components/GlobalHomeContext/index.js';
	import { GlobalHomePage } from '#lib/websites/home/pages/GlobalHomePage/index.js';
</script>

<GlobalHomeContext>
	<GlobalHomePage />
</GlobalHomeContext>
